import { useContext } from "react";

import { VideoPlayerContext } from "./VideoPlayerContext";

export function useVideoPlayer() {
    const context = useContext(VideoPlayerContext);

    if (context === undefined) {
        throw new Error(
            "useVideoPlayer must be used within a VideoPlayerProvider"
        );
    }

    return context;
}
